export default "__VITE_ASSET__DHPUWp4A__"